import { Helmet } from 'react-helmet-async';

type HeadProps = {
  title?: string;
  description?: string;
};
// NOTE: use this validator
// https://cards-dev.twitter.com/validator
// NOTE: i also write this in /public/index.html file
// const socialTitle = 'TVアニメ「見知らぬ女子高生に監禁された漫画家の話」';
// const socialDescription =
//   'サスペンスか、ホラーか、それとも……？\nWebで話題沸騰の監禁同棲ストーリー、待望のTVアニメ化！';
// const socialImg = 'https://i.imgur.com/RyCY1TE.jpeg';
export const Head = ({ title = '', description = '' }: HeadProps = {}) => {
  return (
    <Helmet
      title={title ? `${title} | TVアニメ「見知らぬ女子高生に監禁された漫画家の話」` : undefined}
      defaultTitle="TVアニメ「見知らぬ女子高生に監禁された漫画家の話」公式サイト"
    >
      <meta name="description" content={description} />
      {/* <meta name="theme-color" content="black" /> */}
      {/* <meta name="title" content={socialTitle} />
      <meta name="description" content={socialDescription} /> */}
      {/* Open Graph / Facebook */}
      {/* <meta name="og:type" content="website" />
      <meta name="og:url" content="https://kankin-jk.web.app/april" />
      <meta name="og:title" content={socialTitle} />
      <meta name="og:description" content={socialDescription} />
      <meta name="og:image" content={socialImg} /> */}
      {/* Twitter */}
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@kankinjk" /> */}
    </Helmet>
  );
};
